import React from 'react';

import CustomTh from '../shared/table/CustomTh';
import JobItem from './JobItem';
import ListView from '../shared/lists/ListView';
import useBreakpoints from '../../utilities/useBreakpoints';

const JobList = ({
    addItem,
    canAdd,
    data: { items },
    editItem,
    fetchData
}) => {
    const { isBreakpoint } = useBreakpoints();

    const tableHead = (
        <thead className="table-index-head">
            <tr>
                <CustomTh content="Number" />
                <CustomTh width={isBreakpoint('md') ? '170px' : ''} content="Install" />
                <CustomTh content="Total" />
                <CustomTh hide="md" content="Deposit" />
                <CustomTh hide="sm" content="Balance" />
                <CustomTh width="50px" hide="md" content="Paid" />
                <CustomTh width="80px" />
            </tr>
        </thead>
    );

    const listItems = items && items.map((item) =>
        <JobItem
            editItem={() => editItem(item.id)}
            fetchData={fetchData}
            item={item}
            key={item.id}
        />
    );

    return (
        <ListView
            addItem={addItem}
            canAdd={canAdd}
            itemName="Job"
            items={listItems}
            tableHead={tableHead}
        />
    );
}

export default JobList;